"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../core");
var mobx_1 = require("mobx");
var property_1 = require("./property");
var utils_1 = require("../../utils");
var type_checker_1 = require("../type-checker");
var IdentifierProperty = (function (_super) {
    __extends(IdentifierProperty, _super);
    function IdentifierProperty(propertyName, subtype) {
        var _this = _super.call(this, propertyName) || this;
        _this.subtype = subtype;
        return _this;
    }
    IdentifierProperty.prototype.initialize = function (target, snapshot) {
        mobx_1.extendObservable(target, (_a = {},
            _a[this.name] = mobx_1.observable.ref(snapshot[this.name]),
            _a));
        var _a;
    };
    IdentifierProperty.prototype.willChange = function (change) {
        var identifier = change.newValue;
        if (typeof identifier !== "number" && !utils_1.isValidIdentifier(identifier))
            utils_1.fail("Not a valid identifier: '" + identifier);
        type_checker_1.typecheck(this.subtype, identifier);
        var node = core_1.getMSTAdministration(change.object);
        node.assertWritable();
        var oldValue = change.object[this.name];
        if (oldValue !== undefined && oldValue !== identifier)
            utils_1.fail("It is not allowed to change the identifier of an object, got: '" + identifier + "' but expected: '" + oldValue + "'");
        return change;
    };
    IdentifierProperty.prototype.serialize = function (instance, snapshot) {
        var identifier = instance[this.name];
        if (!this.isValidIdentifier(identifier))
            utils_1.fail("Object does not have a valid identifier yet: '" + identifier + "'");
        snapshot[this.name] = identifier;
    };
    IdentifierProperty.prototype.deserialize = function (instance, snapshot) {
        instance[this.name] = snapshot[this.name];
    };
    IdentifierProperty.prototype.validate = function (snapshot, context) {
        if (!this.isValidIdentifier(snapshot[this.name])) {
            return type_checker_1.typeCheckFailure(type_checker_1.getContextForPath(context, this.name, this.subtype), snapshot[this.name], "The provided identifier is not valid");
        }
        return type_checker_1.typeCheckSuccess();
    };
    IdentifierProperty.prototype.isValidIdentifier = function (identifier) {
        // TODO: MWE, I don't think this isValidIdentifier things makes sense.
        // Who are we to decide? Maybe just rule out empty string
        // Making types.identifier(types.refinement(types.string, (v) => coolCheck(v))) work would be great!
        // On the other hand, this avoids problems with json paths, so maybe we should support all identifiers that don't require further escaping?
        if (typeof identifier !== "number" && !utils_1.isValidIdentifier(identifier))
            return false;
        return this.subtype.is(identifier);
    };
    return IdentifierProperty;
}(property_1.Property));
exports.IdentifierProperty = IdentifierProperty;
//# sourceMappingURL=identifier-property.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mobx-state-tree/lib/types/property-types/identifier-property.js
// module id = 221
// module chunks = 0